import '../../index.css';
var styles = {
  "link": "bp_link_module_link--5b04c",
  "inheritFont": "bp_link_module_inheritFont--5b04c",
  "standalone": "bp_link_module_standalone--5b04c",
  "hasIcon": "bp_link_module_hasIcon--5b04c",
  "icon": "bp_link_module_icon--5b04c"
};
export { styles as default };